<mat-drawer-container style="height: 100%">
  <mat-drawer-content style="background: white">
    <h3>採材実施内容</h3>
    <div class="left-pane">
      <table class="event-list">
        <thead>
        <tr>
          <th>摂取予定日</th>
          <th>日齢</th>
          <th>種類</th>
          <th>対象のロット</th>
        </tr>
        </thead>
        <tbody *ngIf="selectedMeisais && selectedMeisais.length > 0">
        <tr *ngFor="let saizai of selectedMeisais;let saizaiIndex = index;">
          <td>{{saizai?.yoteiDate}}</td>
          <td>{{saizai.yoteiNichirei}}</td>
          <td>{{saizai.shubetsu}}</td>
          <td>{{saizai.taishouLotName}}</td>
        </tr>
        </tbody>
      </table>
      <br>
      <div fxLayout="row wrap" fxLayoutGap="10px">
        <mat-slide-toggle style="margin-left: 20px;" [(ngModel)]="editEvent">予定日を編集する</mat-slide-toggle>
      </div>
    </div>
  </mat-drawer-content>
  <mat-drawer style="width: 40%"opened position="end" mode="side">
    <div class="right-pane">
      <form #jisshiForm="ngForm" *ngIf="!editEvent">
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field appearance="legacy" style="padding-bottom: 10px">
            <mat-label>実施日</mat-label>
            <input matInput [matDatepicker]="jisshiDatePicker" [(ngModel)]="inputForm.jisshiDate" name="jisshiDate" readonly
                   (click)="jisshiDatePicker.open()" (dateChange)="eventService.updateJisshiNichirei2(inputForm, edukeDate)">
            <mat-datepicker-toggle matSuffix [for]="jisshiDatePicker"></mat-datepicker-toggle>
            <mat-datepicker touchUi #jisshiDatePicker disabled="false"></mat-datepicker>
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field>
            <mat-label>
              実施日齢
            </mat-label>
            <input matInput placeholder="実施日齢" required disabled
                   name="jisshiNichirei" [(ngModel)]="inputForm.jisshiNichirei">
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field>
            <mat-label>
              種別
            </mat-label>
            <input matInput placeholder="種別" required disabled
                   name="shubetsu" [(ngModel)]="selectedMeisais[0].shubetsu">
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field>
            <mat-label>
              実施者
            </mat-label>
            <input matInput placeholder="実施者" required
                   name="jisshiSha" [(ngModel)]="inputForm.jisshiSha">
          </mat-form-field>
        </div>
        <div fxLayout="row wrap">
          <div fxLayoutAlign="center center">
            <span>報告書</span>
            <span class="fill-remaining-space"></span>
            <button mat-button class="no-hover-effect" type="button"
                    (click)="fileInput.click()"
                    *ngIf="willUploadFileList.length === 0
                    && !inputForm.filePath">
              <mat-icon>add_circle_outline</mat-icon>
            </button>
            <button mat-button class="no-hover-effect" type="button"
                    *ngIf="(willUploadFileList.length > 0
                    && inputForm.filePath) || blobURL"
                    (click)="eventService.deleteUnUploadedFile(inputForm, willUploadFileList, willDeleteFileList, blobURL);blobURL = ''">
              <mat-icon>remove_circle_outline</mat-icon>
            </button>
            <input hidden (change)="eventService.onFileSelected($event, fileInput, inputForm, willUploadFileList);showUnUploadedFile($event)" #fileInput type="file" id="file">
          </div>
        </div>
        <div fxLayout="row wrap">
          <div *ngIf="blobURL" style="margin-right:12px">
            <iframe [src]="blobURL" style="width: 100%"></iframe>
          </div>
        </div>
        <br>
        <div fxLayout="row wrap" fxLayoutGap="12px" style="margin-bottom: 12px">
          <div [matTooltip]="commonService.getAlertTooltipMessage(jisshiForm)"
               matTooltipPosition="below"
               style="width: fit-content">
            <button mat-raised-button color="primary" [disabled]="jisshiForm.invalid"
                    (click)="register();">登録
            </button>
          </div>
          <div [matTooltip]="!selectedMeisais[0].jisshiDate ? '実施内容が登録されていません。' : ''"
               matTooltipPosition="below"
               style="width: fit-content">
            <button mat-raised-button color="accent"
                    [disabled]="!selectedMeisais[0].jisshiDate"
                    (click)="undo();">取り消し
            </button>
          </div>
          <div [matTooltip]="selectedMeisais[0].jisshiDate ? '実施内容を取り消してから削除してください。' : ''"
               matTooltipPosition="below"
               style="width: fit-content">
            <button mat-raised-button color="warn"
                    [disabled]="!!selectedMeisais[0].jisshiDate"
                    (click)="delete();">削除
            </button>
          </div>
        </div>
      </form>
      <div *ngIf="editEvent">
        <app-event-edit [selectedMeisais]="selectedMeisais"></app-event-edit>
      </div>
    </div>
  </mat-drawer>
</mat-drawer-container>
